import React from 'react';
import { Link, Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import { Mail, Info, Facebook, ArrowUp } from 'lucide-react';
import AboutContent from './AboutContent';
import NotFound from './NotFound';
import HomePage from './HomePage';
import { bookData } from '../data/bookData';

const BookContent = React.lazy(() => import('./BookContent'));

const BookPage = () => {
  const { bookKey } = useParams();
  return (
    <React.Suspense fallback={<div role="status" aria-live="polite">Loading book content...</div>}>
      <BookContent bookKey={bookKey} />
    </React.Suspense>
  );
};

const AuthorWebsite = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleAboutClick = () => {
    navigate('/about');
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 text-gray-800">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:p-2 focus:bg-blue-600 focus:text-white">
        Skip to main content
      </a>
      <header className="bg-white shadow" role="banner">
        <div className="container mx-auto px-4 py-6">
          <h1 className="text-4xl font-bold">
            <Link to="/" className="hover:text-blue-600">Blou Bryant</Link>
          </h1>
          <nav className="mt-4" aria-label="Main Navigation">
            <ul className="flex flex-wrap space-x-4">
              {Object.keys(bookData).map((bookKey) => (
                <li key={bookKey}>
                  <Link 
                    to={`/books/${bookKey}`}
                    className={`hover:text-blue-600 ${location.pathname === `/books/${bookKey}` ? 'font-bold text-blue-600' : ''}`}
                  >
                    {bookData[bookKey].title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>

      <main id="main-content" className="flex-grow container mx-auto px-4 py-8 mb-16">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/books/:bookKey" element={<BookPage />} />
          <Route path="/about" element={<AboutContent />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="bg-gray-800 text-white py-4 fixed bottom-0 left-0 right-0" role="contentinfo">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <div className="flex space-x-6">
              <a href="mailto:your.email@example.com" className="hover:text-gray-300" aria-label="Email Blou Bryant">
                <Mail size={24} />
              </a>
              <button onClick={handleAboutClick} className="hover:text-gray-300" aria-label="About Blou Bryant">
                <Info size={24} />
              </button>
              <a href="https://www.facebook.com/profile.php?id=61555668794791" className="hover:text-gray-300" aria-label="Blou Bryant on Facebook">
                <Facebook size={24} />
              </a>
            </div>
            <button onClick={scrollToTop} className="bg-gray-700 hover:bg-gray-600 text-white p-2 rounded-full" aria-label="Back to top">
              <ArrowUp size={24} />
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthorWebsite;